import PropTypes from "prop-types";
import { useMemo } from "react";
import { useCurrentRewards } from "../../../../hooks/useCurrentRewards";

const RewardAllocationOutcomeSummary = ({ outcome }) => {
  const config = outcome?.outcomeData?.reward_allocation_config || {};
  const rewards = useMemo(
    () => (Array.isArray(config.rewards) ? config.rewards : []),
    [config.rewards]
  );

  const { rewardsById, loading, error } = useCurrentRewards(
    config,
    outcome?.outcomeData
  );

  const formatStrategyName = (strategy) => {
    if (strategy === "PROBABILITY_BASED") return "Probability Based";
    if (strategy === "ORDER_BASED") return "Order Based";
    return strategy || "Not set";
  };

  const resolveRewardName = (reward) => {
    const current = rewardsById[reward.reward_id || reward.rewardId];
    return (
      current?.name || current?.rewardName || reward.reward_name || reward.reward_id
    );
  };

  const renderRewardsList = () => {
    if (loading) return <span className="field-value">Loading...</span>;
    if (error)
      return <span className="field-value error">Error loading rewards</span>;
    const list =
      rewards.length > 0
        ? rewards.map(resolveRewardName).join(", ")
        : "No rewards selected";
    return <span className="field-value">{list}</span>;
  };

  return (
    <>
      <div className="display-flex justify-content-space-between align-items-center w-100 font-bold pb-2">
        Reward Allocation
      </div>
      <hr style={{ marginBottom: "10px" }} color="#DFDFDF" />
      <div style={{ width: "100%" }}>
        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">Distribution Strategy:</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">
              {formatStrategyName(config.distribution_strategy)}
            </span>
          </div>
        </div>

        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">Fallback Logic:</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">
              {config.rollover_enabled ? "Active" : "Inactive"}
            </span>
          </div>
        </div>

        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">Selected Rewards:</span>
          </div>
          <div className="field-pair-two-column">{renderRewardsList()}</div>
        </div>
      </div>
    </>
  );
};

RewardAllocationOutcomeSummary.propTypes = {
  outcome: PropTypes.object.isRequired,
};

export default RewardAllocationOutcomeSummary;
